// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"cc41ff69","215":"cc41ff69","552":"cc41ff69","618":"cc41ff69","748":"cc41ff69","809":"cc41ff69","828":"cc41ff69","861":"cc41ff69"}[chunkId] + ".chunk.css";
};